export default __webpack_public_path__ + "static/media/299.194b4956.jpg";